// Item library evaluate codes for /roads-sewers/main-services-substation dev-mode
// display — mirrors prelimsMapping.ts's description -> code lookup pattern. The
// Main Service Trenching table looks its rows up here by description rather than
// hardcoding codes inline, so codes stay in one place as more are added.

export interface MainServicesEvaluateCodeItem {
  description: string;
  code: string;
}

export const MAIN_SERVICE_TRENCHING_EVALUATE_CODES: MainServicesEvaluateCodeItem[] = [
  { description: 'Water main trenching', code: 'ALP113' },
  { description: 'Electric LV main trenching', code: 'ALP114' },
  { description: 'Electric HV main trenching to substation', code: 'ALP114' },
  { description: 'Gas main trenching', code: 'ALP114' },
  { description: 'Streetlighting main', code: 'ALP114' },
  { description: 'BT main ducting', code: 'ALP115' },
  { description: 'Virgin Media main ducting', code: 'ALP115' },
  { description: 'BT Joint Box JBF 104', code: 'ALP116' },
  { description: 'BT Joint Box JBF 104C 750mm deep', code: 'ALP118' },
  { description: 'BT Joint Box JBF 106D 900 deep', code: 'ALP119' },
  { description: 'BT Joint Box JBF 106 1200 deep', code: 'ALP121' },
  { description: 'BT Joint Box JBF 104 (utilising pre-formed Stakkabox)', code: 'ALP122' },
  { description: 'BT Joint Box JBF 104C 750mm deep (utilising pre-formed Stakkabox)', code: 'ALP123' },
  { description: 'BT Joint Box JBF 106D 900 deep (utilising pre-formed Stakkabox)', code: 'ALP124' },
  { description: 'BT Joint Box JBF 106 1200 deep (utilising pre-formed Stakkabox)', code: 'ALP125' },
  { description: 'Virgin Footway Box FW4', code: 'ALP126' },
  { description: 'Virgin Footway Box FW6', code: 'ALP127' },
  { description: 'Virgin Footway Box FW10', code: 'ALP128' },
  { description: 'Streetlight connection pits', code: 'ALP129' },
  { description: 'Road crossing duct n ex 100mmØ', code: 'ALP130' },
  { description: "EO for excavating service trenches off site in 'live' footway", code: 'ALP133' },
  // "No code" in the source spec — deliberately unmapped: Substation base &
  // maintenance drive, b/f from Substation Base sheet, EO 2/3/4 way ducting
  // (BT and Virgin Media both use this same text), Streetlights & columns,
  // Combined Service trenching, 150/225/300/450/600mmØ duct, 100mmØ/150mmØ
  // duct - Red electric.
];

export function findMainServiceTrenchingEvaluateCode(description: string): string | undefined {
  return MAIN_SERVICE_TRENCHING_EVALUATE_CODES.find((i) => i.description === description)?.code;
}
